import React from 'react';
import Grid from '@material-ui/core/Grid';
import { FastField, Field } from 'formik';
import CustomTextField from './TextField';
import { useSelector } from 'react-redux';
import helpers from '../../../utils/helpers';

const FieldsLinesStrip = ({ loading }) => {

  const subSystems = useSelector(state => state.vehicle.subSystems);
  const vehicleType = useSelector(state => state.vehicle.vehicleType);
  const lineGrants = useSelector(state => state.line.grants);
  const lineServices = useSelector(state => state.line.services);
  const vehicleClassification = useSelector(state => state.vehicle.vehicleClassification);

  return (
    <>
      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Quant. permissionários'
          name='nuPermissionarios'
          type='number'
          inputProps={{
            max: 999,
          }}
          onInput={e => {
            e.target.value = Math.max(0, parseInt(e.target.value))
              .toString()
              .slice(0, 3);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label="Categoria"
          name="cdCategoria"
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label="None" value="">
            Selecione
          </option>
          {helpers.ordernarArray({ data: vehicleClassification, field: 'deClassificacaoVeiculo' })?.map((type, index) => {
            return (
              <option key={`type-${index}`} value={type.cdClassificacaoVeiculo}>
                {type.deClassificacaoVeiculo}
              </option>
            );
          })}
        </Field>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Sistema'
          name='cdSubSistema'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
          {helpers.ordernarArray({ data: subSystems, field: 'deSubSistema' })
            ?.filter(entry => {
              return entry.boComplementar === true;
            })
            .map((type, index) => {
              return (
                <option key={`type-${index}`} value={type.cdSubSistema}>
                  {type.deSubSistema}
                </option>
              );
            })}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Outorga'
          name='cdLinhaOutorga'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
          {helpers.ordernarArray({ data: lineGrants, field: 'deLinhaOutorga' })?.map((type, index) => {
            return (
              <option key={`type-${index}`} value={type.cdLinhaOutorga}>
                {type.deLinhaOutorga}
              </option>
            );
          })}
        </Field>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Serviço'
          name='cdLinhaServico'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
          {helpers.ordernarArray({ data: lineServices, field: 'deLinhaServico' })?.map((type, index) => {
            return (
              <option key={`type-${index}`} value={type.cdLinhaServico}>
                {type.deLinhaServico}
              </option>
            );
          })}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FastField
          component={CustomTextField}
          label='Edital'
          name='nuEdital'
          inputProps={{
            maxLength: 30,
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Tipo de veículo'
          name='cdTipoVeiculo'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
          {helpers.ordernarArray({ data: vehicleType, field: 'deTipoVeiculo' })?.map((type, index) => {
            return (
              <option key={`type-${index}`} value={type.cdTipoVeiculo}>
                {type.deTipoVeiculo}
              </option>
            );
          })}
        </Field>
      </Grid>
    </>
  );
};

export default FieldsLinesStrip;